import React, { useState } from "react";

const newsArticles = [
  {
    id: 1,
    title:
      "Important Update from Benue Education Quality Assurance and Examinations Board",
    description:
      "The Benue Education Quality Assurance and Examinations Board is excited to announce the latest updates on developments in state education. For more details, please click on the links below.",

    files: [
      {
        url: "/media/pdf/AN UPDATE OF UNAPPROVED SCHOOLS.pdf",
        label: "🚫 List of Unapproved Private Schools",
        className: "text-indigo-700",
      },
      {
        url: "/media/pdf/CERTIFICATE OF CONSENT (1ST BATCH).pdf",
        label: "✅ List of Private Schools with Full Approval",
        className: "text-indigo-700",
      },
      {
        url: "/media/pdf/SUMMARY FOR WASSCE AND NECO-1.pdf",
        label: "📝 2024 WASSCE/NECO: Data of Schools Accredited",
        className: "text-indigo-700",
      },
      {
        url: "/media/pdf/STUDENTS EXCHANGE PROGRAMME FOR 19 NORTHERN STATES.pdf",
        label:
          "🏫 List of Successfully Admitted Candidates for Basic 7 (2024/2025)",
        className: "text-indigo-700",
      },
      {
        url: "/media/pdf/Release of Admission List For Basic 7 Sign.pdf",
        label: "📄 Important Note on Admission for Basic 7 (2024/2025)",
        className: "text-indigo-700",
      },
      {
        url: "/media/pdf/Benue Sep in other States updated_020118.pdf",
        label: "🌍 Benue SEP in Other States",
        className: "text-red-700",
      },
      {
        url: "/media/pdf/SEP IN GOVERMENT COLLEGE MAKURDI updated_015906.pdf",
        label: "🏫 SEP in Government College Makurdi",
        className: "text-red-700",
      },
      {
        url:
          "/media/pdf/SEP IN GOVERNMENT GIRLS MODEL SECONDARY SCHOOL, ALIADE updated_015839.pdf",
        label:
          "👩‍🎓 SEP in Government Girls Model Secondary School, Aliade",
        className: "text-red-700",
      },
    ],
  },
];

const NewsSection = () => {
  const [showAll, setShowAll] = useState(false);

  return (
    <section className="bg-white md:pl-12 md:pt-12">
      <div className="container max-w-5xl">
        <h2 className="text-2xl font-bold text-red-700 mb-4 border-b border-red-200 pb-2">
          Latest News
        </h2>

        {newsArticles.map((article) => {
          const filesToShow = showAll
            ? [...article.files].reverse()
            : article.files.slice(-5).reverse();

          return (
            <div
              key={article.id}
              className="border border-gray-200 rounded-lg p-4"
            >
              <p className="text-gray-600 mb-4 text-sm leading-relaxed">
                {article.description}
              </p>

              <div className="space-y-2">
                {filesToShow.map((file, index) => (
                  <a
                    key={index}
                    href={file.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`block text-sm font-medium hover:underline ${file.className}`}
                  >
                    {file.label}
                  </a>
                ))}
              </div>

              {article.files.length > 5 && (
                <button
                  onClick={() => setShowAll(!showAll)}
                  className="mt-3 text-xs font-semibold text-red-600 hover:underline"
                >
                  {showAll ? "Show Less" : "View All"}
                </button>
              )}
            </div>
          );
        })}
      </div>

      {/* YouTube Embed */}
      <div className="mt-8 pr-8">
        <iframe
          title="Introducing e-Dossier"
          className="rounded-lg w-full h-56 md:h-80"
          src="https://www.youtube.com/embed/oSuXxpRX0KM"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        ></iframe>
      </div>
    </section>
  );
};

export default NewsSection;
